import {filtersCustomScheme} from '@/utils/filtersCommon'

export default {
  //---name
  name: 'filtersCustom',
  //---components
  /**
   * @emit
   * change
   */
  //---data
  data () {
    return {
      filtersGroup: []
    }
  },
  //---hooks
  created: function () {
    this.filtersGroup = filtersCustomScheme.map((event,index) => {
      return Object.assign({},event, {
        isImageLoaded: false,
        id: index
      });
    });
  },
  computed: {},
  //---methods
  methods: {
    imageLoaded(index) {
      this.filtersGroup[index].isImageLoaded = true;
    },
    setCurrentFiltersCustom(filter) {
      this.$emit('change',{[filter.type]: 1});
    },
  }
}
